// LWA : pastille Quick Add sur le coin bas-droit de l'image de chaque card.
(function(){
  var BTN=36, GAP=12;
  function place(){
    document.querySelectorAll('.card-wrapper').forEach(function(w){
      var qa=w.querySelector('.quick-add');var inner=w.querySelector('.card__inner');
      if(!qa||!inner)return;
      if(qa.parentElement!==w)w.appendChild(qa);
      var top=inner.offsetTop+inner.offsetHeight-BTN-GAP;
      if(top>0){qa.style.top=top+'px';qa.style.bottom='auto';qa.setAttribute('data-lwa-pos','1');}
    });
  }
  var t;function lazy(){clearTimeout(t);t=setTimeout(place,120)}
  if(document.readyState!=='loading')place();else document.addEventListener('DOMContentLoaded',place);
  window.addEventListener('resize',lazy);window.addEventListener('load',place);
  new MutationObserver(lazy).observe(document.documentElement,{childList:true,subtree:true});
})();
